<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <ul>
            <div class="pci"><img :src="form.url" alt="" width="300px" /></div>
            <div class="name">{{ form.name }}</div>
            <div class="name">{{ form.introduce }}</div>
            <li v-for="item in form.list" :key="item.id" class="li-item">
              <div class="hotel" v-if="item.id == 3">
                <a href="http://www.haihetour.com" target="_blank">{{
                  item.hotel
                }}</a>
              </div>
              <div class="hotel" @click="goToDetail(item)" v-else>
                {{ item.hotel }}
              </div>

              <div class="address">地址：{{ item.address }}</div>
              <div class="address">联系电话：{{ item.phone }}</div>
              <div class="hotelIntroduce">{{ item.hotelIntroduce }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      form: {
        url: require("@/assets/images/lybk1.jpg"),
        name: "酒店板块",
        introduce:
          "天津旅游集团不断开发旅游产品和旅游市场，天津津旅海河游船公司是天津独家经营海河观光游览的接待单位。",
        list: [
          {
            id: 1,
            hotel: "天津津旅商务信息技术股份有限公司",
            address: "天津市河西区友谊路18号",
            phone: "022-58559191",
            hotelIntroduce: "天津津旅商务信息技术股份有限公司",
          },
          {
            id: 2,
            hotel: "天津国旅海外国际旅游有限责任公司",
            address: "天津市河西区友谊路22号",
            phone: "022-58559988",
            hotelIntroduce: "AAAAA级旅行社 全国百强国际旅行社",
          },
          {
            id: 3,
            hotel: "天津津旅海河游船股份有限公司",
            address: "天津市河北区翔纬路旺海国际B座20层。",
            phone: "022-58175050",
            hotelIntroduce: "经营海河游船旅游大型国有公司",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    goToDetail(item) {
      if (item.id == 2) {
        this.$router.push("/tjgl");
      } else if (item.id == 3) {
        this.$router.push("http://www.haihetour.com");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 0px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      .pci {
        margin-top: 20px;
        text-align: center;
      }
      .name {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #1c5c88;
        text-align: center;
        margin-top: 15px;
      }
      .hotel {
        cursor: pointer;
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        font-weight: bold;
      }
      .hotel:hover {
        color: red;
        text-decoration: underline;
      }
      .address {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #777;
      }
      .hotelIntroduce {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #2d5b89;
      }
      .li-item {
        
        a {
          color: #333;
          text-decoration: none;
        }
        a:hover {
          color: red;
          text-decoration: underline;
        }
        text-align: center;
        width: 100%;
        // height: 202px;
        background: #ffffff;
        // border-bottom: 1px solid #e5e5e5;
        padding: 15px 103px 20px 40px;
        box-sizing: border-box;
      }
      .wp_single.wp_column_article {
        padding: 15px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>